import styles from './OSBadges.module.css';

// orbit shared.jsx OSBadges와 동치 — 원형 16×16 + 한 글자.
// Phase 8: backend는 utils.apps.store 원본 code('aos','ios',...) 배열을 보낸다.

export type OSName = 'AOS' | 'iOS' | 'Web';

type OSInput = OSName | string;

interface OSBadgesProps {
  os: OSInput[];
  empty?: string;
}

const CODE_TO_LABEL: Record<string, OSName | string> = {
  aos: 'AOS',
  ios: 'iOS',
  web: 'Web',
};

const LABEL_CLASS: Record<string, string> = {
  AOS: styles.aos,
  iOS: styles.ios,
  Web: styles.web,
};

const BADGE_GLYPH: Record<string, string> = {
  AOS: 'A',
  Web: 'W',
};

// macOS/iOS 환경에서만 Apple 시스템 폰트의 PUA 글리프(U+F8FF)를 렌더링한다.
// 그 외(Windows/Linux Chrome 등)에서는 빈 박스 회피를 위해 소문자 'i'로 fallback.
function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  // iOS, iPadOS(=Mac User-Agent), macOS Safari/Chrome 모두 매칭.
  return /Mac|iPhone|iPad|iPod/i.test(ua);
}

function iosGlyph(): string {
  return isApplePlatform() ? '' : 'i';
}

function toLabel(input: OSInput): string {
  if (!input) return '';
  const trimmed = input.trim();
  const lower = trimmed.toLowerCase();
  if (lower in CODE_TO_LABEL) return CODE_TO_LABEL[lower];
  if (trimmed === 'AOS' || trimmed === 'iOS' || trimmed === 'Web') return trimmed;
  return trimmed.toUpperCase();
}

export function OSBadges({ os, empty = '미지정' }: OSBadgesProps) {
  if (!os || os.length === 0) {
    return <span className={styles.empty}>{empty}</span>;
  }
  const labels = Array.from(new Set(os.map(toLabel).filter(Boolean)));
  if (labels.length === 0) {
    return <span className={styles.empty}>{empty}</span>;
  }
  return (
    <span className={styles.row}>
      {labels.map((name) => (
        <span
          key={name}
          className={[styles.badge, LABEL_CLASS[name] ?? ''].join(' ')}
          aria-label={name}
          title={name}
        >
          {name === 'iOS' ? iosGlyph() : (BADGE_GLYPH[name] ?? name.charAt(0).toUpperCase())}
        </span>
      ))}
    </span>
  );
}
